import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    dialogContent: {
        display: 'flex',
        gap: 20
    },
    selectPreference: {
        minWidth: 200,
    },
    checkBoxPreference: {
        color: '#43a047 !important'
    },
    dropdownContent: {
        display: 'flex',
        flexDirection: 'column'
    }
}))

export default useStyles